export default __webpack_public_path__ + "static/media/icone-guarde-seu-documento.bc549a51.png";